package one.healthium.domain.common


import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.descriptors.listSerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder


@Serializable(with = InsetsSerializer::class)
data class Insets(
    val top: Int,
    val left: Int,
    val bottom: Int,
    val right: Int,
)

@OptIn(ExperimentalSerializationApi::class)
object InsetsSerializer : KSerializer<Insets?> {
    override val descriptor: SerialDescriptor = listSerialDescriptor<Int>()

    override fun deserialize(decoder: Decoder): Insets? {
        val list = decoder.decodeSerializableValue(ListSerializer(Int.serializer()))
        if (list.isEmpty() || list.size < 4) return null
        return Insets(
            top = list[0],
            left = list[1],
            bottom = list[2],
            right = list[3],
        )
    }

    override fun serialize(encoder: Encoder, value: Insets?) {
        val list = if (value == null) emptyList() else listOf(value.top, value.left, value.bottom, value.right)
        encoder.encodeSerializableValue(ListSerializer(Int.serializer()), list)
    }
}